function parseGradient (gradient) {
  const {
    type = 'solid',
    color = '#ffffff',
    secondColor = '#000000',
    deg = 90,
    size = 100
  } = gradient

  switch(type) {
    case 'solid':
      return `linear-gradient(${color}, ${secondColor})`

		case 'linearGradient':
      return `linear-gradient(${deg}deg, ${color}, ${secondColor})`

		case 'radialGradient':
			return `radial-gradient(${size}% ${size}%, ${color}, ${secondColor})`
	}
}

function parseBackground (background) {
  const { layers, color, clip } = background
  const transparent = 'rgb(0 0 0 / 0)'
  const jss = {}

  if (layers) {
    const normalizedLayers = layers.map(
      layer => {
        switch (layer.type) {
          case 'color': {
            return {
              image: `linear-gradient(${layer.value || transparent}, ${layer.value || transparent})`,
              size: 'auto',
              repeat: 'repeat'
            }
          }
  
          case 'gradient': {
            return {
              image: layer.value && parseGradient(layer.value),
              size: 'auto',
              repeat: 'repeat'
            }
          }
  
          case 'image': {
            return {
              image: layer.value && `url(${layer.value.src})`,
              size: (layer.value && layer.value.size) || 'auto',
              repeat: (layer.value && layer.value.repeat) || 'repeat'
            }
          }
        }
      }
    )

    jss.backgroundImage = normalizedLayers.map(({ image }) => image)
    jss.backgroundSize = normalizedLayers.map(({ size }) => size)
    jss.backgroundRepeat = normalizedLayers.map(({ repeat }) => repeat)
  }

  if (color) { jss.backgroundColor = color }

  if (clip) {
    if (clip === 'text') {
      jss.backgroundClip = 'text'
      jss.color = 'transparent'
      jss['-webkit-background-clip'] = 'text'
    } else {
      jss.backgroundClip = clip
    }
  }

  if(jss.backgroundImage) {
    jss.backgroundImage = jss.backgroundImage.join(',')
  }
  
  if(jss.backgroundSize) {
    jss.backgroundSize = jss.backgroundSize.join(',')
  }
  
  if(jss.backgroundRepeat) {
    jss.backgroundRepeat = jss.backgroundRepeat.join(',')
  }

  return jss
}

export default parseBackground
